module.exports = __webpack_public_path__ + "img/question-icon.85834b42.svg";